import InstallDecommissionWorkspace from './InstallDecommissionWorkspace';

export default InstallDecommissionWorkspace;
